//React Library
import React, { useState, useEffect } from "react";

//Material UI Styles
import { makeStyles } from "@material-ui/core/styles";

//Material UI Components
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import MuiPhoneNumber from "material-ui-phone-number";
import Visibility from "@material-ui/icons/Visibility";
import FormControl from "@material-ui/core/FormControl";
import { CircularProgress } from "@material-ui/core";
import PhotoCamera from "@material-ui/icons/PhotoCamera";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import CustomToolTip from "../../Global/PasswordGuileline";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import DoneAllIcon from "@material-ui/icons/DoneAll";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PhoneInput from "react-phone-number-input/input";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import DeleteIcon from "@material-ui/icons/Delete";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { Switch } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Tooltip from "@material-ui/core/Tooltip";

//Global Elements
import GlobalApi from "../../Global";
import Colors from "../../Global/colors";
import refresh_token from "../../Global/refresh_token";
import {
  hasValidLength,
  hasNumber,
  hasMixed,
  hasSpecial,
} from "../../Global/Password";

//Custom Css + Images
import "./team.css";
import swal from "@sweetalert/with-react";
import Delete from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import DeleteG from "../../Assets/deleteG.png";
import EditG from "../../Assets/editG.png";
import help from "../../Assets/help_icon.png";
import helpAr from "../../Assets/help_icon_ar.png";

//Redux
import { addUser } from "../../Redux/Actions/userAction";
import { addTeam } from "../../Redux/Actions/teamAction";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  input: {
    display: "none",
  },
  textField: {
    backgroundColor: Colors.globalColor5,
    border: "none",
    borderRadius: 5,
  },
  resize: {
    padding: "7px",
  },
  password: {
    padding: "2px",
  },
  switchBase: {
    color: "#818181",
    padding: "1px",
    "&$checked": {
      "& + $track": {
        backgroundColor: "#043077",
      },
    },
  },
  thumb: {
    color: "white",
    width: "20px",
    height: "20px",
    margin: "1px",
  },
  track: {
    borderRadius: "20px",
    width: "200px",
    backgroundColor: "#818181",
    opacity: "1 !important",
    "&:after, &:before": {
      color: "white",
      fontSize: "11px",
      backgroundColor: "#818181",
    },
    "&:after": {
      content: "'activate'",
      left: "7px",
    },
    "&:before": {
      content: "'deactivate'",
      right: "8px",
    },
  },
  checked: {
    color: "#043077 !important",
    transform: "translateX(50px) !important",
  },
}));

//Main Function
function Team({ isOnboarding = false }) {
  let { t } = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  let data = useSelector((state) => state.companyReducer.company);
  let company = useSelector((state) => state.companyReducer.company);
  let data2 = useSelector((state) => state.userReducer.user);
  const [currentCompany, setCurrentCompany] = useState(data);
  const [btnLoader, setBtnLoader] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [companiesArr, setCompaniesArr] = useState([]);
  const [profileImageUrl, setProfileImageUrl] = useState("");
  const [signatureUrl, setSignatureUrl] = useState("");
  const [userData, setUserData] = useState(data2);
  const [packageDetails, setPackageDetails] = useState(null);
  const [token, setToken] = useState(data2.token);
  const [organizationId, setOrganizationId] = useState(data2.organization_id);
  const [editMode, setEditMode] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [currentEditUser, setCurrentEditUser] = useState("");
  const [teams, setTeams] = useState(null);
  const [openOnb, setOpenOnb] = React.useState(false);
  const [licenses, setLicenses] = useState([]);
  const [permissions_obj, setPermissionObj] = useState({});
  const [inspectorPremissions, setInspectorPremissions] = useState([
    "Data Management",
    "Schedule Management",
    "Manage Response Sets",
    "Action",
    "Manage Report Preferences",
    "Template Creation",
    "Data Access",
  ]);
  const [managementPremissions, setManagementPremissions] = useState([
    "Workflow",
    "Analytics",
    "Activity Log",
    "License and Billing Management",
    "Billing Management",
  ]);
  const history = useHistory();
  const [teamData, setTeamData] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    email: "",
    password: "",
    license_id: "",
    role: "admin",
    confirmPassword: "",
    profilePic: null,
    signature_filename: "",
    signature: null,
  });
    const [reason, setReason] = useState("");
  let [errorObj, setErrorObj] = useState({
    first_name: "",
    last_name: "",
    job_title: "",
    role: "",
    email: "",
    license_id: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });
  const [values, setValues] = React.useState({
    showPassword: false,
    showPasswordConfirm: false,
  });
  const dispatch = useDispatch();

  function handleInputChange(event) {
    let { name, value } = event.target;
    setTeamData({
      ...teamData,
      [name]: value,
    });
  }

    function handleInputChange2(event) {
    let { name, value } = event.target;
    setReason(value);
  }

  const handleDelete = () => {
    if(reason == ""){
      swal("Error","Reason is Required","error")
      return;
    }
    swal({
      title: t("Are you sure?"),
      text: "Are you sure you want to proceed with user deletion?",
      icon: "warning",
      buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
      dangerMode: true,
    }).then(async function(isConfirm) {
      if (isConfirm) {
        removeTeamMember(data2.user_id);
      } else {
        console.log("Canceled");
      }
    });
  }


  function handlePhoneInputChange(value) {
    console.log(value);
    setTeamData({
      ...teamData,
      phone: value,
    });
  }

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };
  const handleClickShowPasswordConfirm = () => {
    setValues({ ...values, showPasswordConfirm: !values.showPasswordConfirm });
  };

  const onCheckCompany = (value, index) => {
    console.log("Before", companies);
    let _companies = [...companies];
    _companies[index].checked = value;

    console.log("After", _companies);
    setCompanies(_companies);
  };

  const handleStatus = (userId) => {
    console.log("id", userId);
  };

  const handleRoleChange = (index, value) => {
    console.log("**************** Companies>>>>>>>", value);
    let _companies = [...companies];
    _companies[index].role = value;

    let permissions = [..._companies[index].permissions];
    console.log("**************** permissions>>>>>>>", permissions);

    if (value == "inspector") {
      permissions.forEach((permission) => {
        if (inspectorPremissions.includes(permission.title)) {
          permission.checked = true;
        } else {
          permission.checked = false;
        }
      });
    } else if (value == "management") {
      permissions.forEach((permission) => {
        if (managementPremissions.includes(permission.title)) {
          permission.checked = true;
        } else {
          permission.checked = false;
        }
      });
    } else {
      permissions.forEach((permission) => {
        permission.checked = true;
      });
    }
    _companies[index].permissions = permissions;

    setCompanies(_companies);
  };

  const onCheckPermission = (value, index, subIndex) => {
    console.log("Before", companies);
    let _companies = [...companies];
    _companies[index].permissions[subIndex].checked = value;
    console.log("After", _companies);
    setCompanies(_companies);
  };

  async function logout() {
    console.log("DELETE 1 CALLED");
    let localstorage = localStorage.getItem("UserData");

    let data = JSON.parse(localstorage);
    fetch(GlobalApi + "/DeviceRecord/delete_device_record", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + data.token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify({
        device_record_id: data.device_id,
      }),
    })
      .then((res) => res.json())
      .then(async (resJson) => {
        console.log("DELETE RESPONSE IF DEVICE API", resJson);

        console.log("all Dispatches Called");
        // dispatch(confirmDeleteUser());
        // dispatch(removeCompany());
        // dispatch(removeCompanyArr());
        // dispatch(removeIndustryArr());
        history.replace("/signin");
        localStorage.clear();
      })
      .catch((error) => console.log("error", error));
  }

  // async function confirmDeleteUser(userId, orgId) {
  //   if (data2.user_id === userId && orgId != null) {
  //     if (teams?.length > 1) {
  //       swal(
  //         t("Warning"),
  //         "Before proceed to deletion, you need to delete of all user accounts.",
  //         "error"
  //       );
  //     } else {
  //       swal({
  //         title: t("Are you sure?"),
  //         text: "Are you sure you want to proceed with the deletion?",
  //         icon: "warning",
  //         buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
  //         dangerMode: true,
  //       }).then(async function(isConfirm) {
  //         if (isConfirm) {
  //           removeTeamMember(userId);
  //         } else {
  //           console.log("Canceled");
  //         }
  //       });
  //     }
  //   } else {
  //     swal({
  //       title: t("Are you sure?"),
  //       text: "Are you sure you want to proceed with user deletion?",
  //       icon: "warning",
  //       buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
  //       dangerMode: true,
  //     }).then(async function(isConfirm) {
  //       if (isConfirm) {
  //         removeTeamMember(userId);
  //       } else {
  //         console.log("Canceled");
  //       }
  //     });
  //   }
  // }

  async function confirmDeleteUser(userId, orgId) {
    if (data2.user_id === userId ) {
      setOpenOnb(true)
    } else {
      swal({
        title: t("Are you sure?"),
        text: "Are you sure you want to proceed with user deletion?",
        icon: "warning",
        buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
        dangerMode: true,
      }).then(async function(isConfirm) {
        if (isConfirm) {
          removeTeamMember(userId);
        } else {
          console.log("Canceled");
        }
      });
    }
  }

  async function removeTeamMember(userId) {
    try {
      fetch(GlobalApi + "/User/consent_for_deletion", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          reason: reason ? reason : "",
          feedback : ""
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("res>>>>>",res)
          if (res.msg === "success") {
            fetch(GlobalApi + "/user/freeze_users", {
              method: "post",
              headers: new Headers({
                Authorization: "Bearer " + token,
                "Content-Type": "application/json",
              }),
              body: JSON.stringify({
                user_id: userId,
              }),
            })
              .then((response2) => response2.json())
              .then(async (res2) => {
                console.log("remove user response >>>>", res2);
                if (res2.status === "Success") {
                  await swal(
                    t("Success"),
                    t("Your Account has been deleted, Please check your email for further details"),
                    "success"
                  );
                  getTeamData(data.id);
                  getPackageDetails();
                } else {
                  // alert(res.err);
                }
              })
              .catch((err) => console.log(err));

            if (userId == data2.user_id) {
              logout();
            }
          }
        });

      //  let req = await fetch(Global.apiUrl + '/User/consent_for_deletion', {
      //   method: 'post',
      //   headers: new Headers({
      //     Authorization: 'Bearer ' + token,
      //     'Content-Type': 'application/json',
      //   }),
      //   body: JSON.stringify({
      //     user_id: user_id
      //   })
      // })
      // let res = await req.json();
      // console.log('consent_for_deletion user response >>>>', res);
      // if (res.msg === 'success') {
      //   try {
      //     let req = await fetch(Global.apiUrl + '/user/freeze_users', {
      //       method: 'post',
      //       headers: new Headers({
      //         Authorization: 'Bearer ' + token,
      //         'Content-Type': 'application/json',
      //       }),
      //       body: JSON.stringify({
      //         // user_id: userData?.user_id
      //         user_id: user_id
      //       }),
      //     })
      //     let response = await req.json();
      //     console.log('Permanent User Deleted Response *****>>>>>', response);
      //     if (response.status === 'Success') {
      //       setFormDataAdd(false);
      //       if (loginUser?.user_id === user_id) {
      //         AsyncStorage.clear();
      //         dispatch(confirmDeleteUser());
      //       }
      //       else {
      //         showAlert(t('alert'), t('user_deleted'), t('ok'))
      //         fetchUsers(selectedCompany);
      //         fetchEntity();
      //         getPackageDetails()
      //         clearFormData();
      //         getAllLicenses();
      //       }
      //     } else {
      //       setFormDataAdd(false);
      //     }

      //   } catch (error) {
      //     console.log('User Delete Error >>>', error);
      //   }

      // }
    } catch (error) {
      console.log("Req Error ****>>>>>", error);
    }
  }

  // async function confirmDeleteUser(userId) {
  //   swal({
  //     title: t("Are you sure?"),
  //     text: t("All Data connected to this account will be deleted"),
  //     icon: "warning",
  //     buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
  //     dangerMode: true,
  //   }).then(async function(isConfirm) {
  //     if (isConfirm) {
  //       fetch(GlobalApi + "/user/freeze_users", {
  //         method: "post",
  //         headers: new Headers({
  //           Authorization: "Bearer " + token,
  //           "Content-Type": "application/json",
  //         }),
  //         body: JSON.stringify({
  //           user_id: userId,
  //         }),
  //       })
  //         .then((response) => response.json())
  //         .then(async (res) => {
  //           console.log("remove user response >>>>", res);
  //           if (res.status === "Success") {
  //             await swal(
  //               t("Success"),
  //               t("Team member has been removed successfully"),
  //               "success"
  //             );
  //             getTeamData(data.id);
  //             getPackageDetails();
  //           } else {
  //             // alert(res.err);
  //           }
  //         })
  //         .catch((err) => console.log(err));

  //       if (userId == data2.user_id) {
  //         logout();
  //       }
  //     } else {
  //       console.log("Canceled");
  //     }
  //   });
  // }

  const editUser = (key, userId) => {
    setEditMode(true);
    setCurrentEditUser(userId);
    let currentUser = teams[key];
    console.log("XXXXXXXXXXXXXXXXXXXXXXXXXXXXX", currentUser);
    setTeamData({
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      job_title: currentUser.job_title,
      license_id: currentUser?.license?.license_id,
      email: currentUser.email,
      profilePic: currentUser.avatar,
      role: currentUser.role,
      signature_filename: currentUser.signature_filename,
      signature: currentUser.signature,
      password: "",
      confirmPassword: "",
    });
    setPhoneNumber(currentUser.phone);
    setCompanies(currentUser.company);
    console.log(teams[key]);
  };

    const handleCloseOnb = () => {
    setOpenOnb(false);
  };


  const handleCancel = () => {
    setEditMode(false);
    setTeamData({
      first_name: "",
      last_name: "",
      job_title: "",
      license_id: "",
      role: "admin",
      email: "",
      password: "",
      confirmPassword: "",
    });
    setPhoneNumber("");
    getCompaniesDetail(token, userData.organization_id, userData);
    setErrorObj({
      first_name: "",
      last_name: "",
      job_title: "",
      role: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
    });
  };

  const resetFields = () => {
    setTeamData({
      first_name: "",
      last_name: "",
      job_title: "",
      license_id: "",
      email: "",
      role: "admin",
      password: "",
      confirmPassword: "",
      signature_filename: "",
      signature: null,
    });
    setPhoneNumber("");
  };

  async function getCompaniesDetail(Token, OrganizationId, UserData) {
    let params1 = {
      organization_id: OrganizationId,
    };
    let query1 = Object.keys(params1)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params1[k]))
      .join("&");

    let getPermissions = await fetch(
      GlobalApi + "/Permission/get_all_company_permissions?" + query1,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + Token,
          "Content-Type": "application/json",
        },
      }
    );
    let permissionsJson = await getPermissions.json();
    if (permissionsJson.status === "Success") {
      let finalArray = await permissionsJson.data.map((item) => {
        return { ...item, role: "admin" };
      });

      console.log("**************** Companies>>>>>>>", finalArray);

      setCompanies(finalArray);
    }

    // else if (userData?.super_admin == false) {
    //   console.log('NOt Super Admin user >>>',)
    //   let getPermissions = await fetch(Global.apiUrl + '/Permission/get_all_company_permissions?' + query1, {
    //     method: 'GET',
    //     headers: {
    //       Authorization: 'Bearer ' + token,
    //       'Content-Type': 'application/json',
    //     },
    //   });
    //   let permissionsJson = await getPermissions.json();
    //   console.log('single company >>>>>>', permissionsJson);
    //   if (permissionsJson.status === 'Success') {
    //     if (handleGlobelCompanies != undefined) {
    //       handleGlobelCompanies(permissionsJson.data)
    //     }
    //     let industry_data = [];
    //     userData.companies.map(v => {
    //       industry_data.push({
    //         label: v.company_name,
    //         value: v.id,
    //       })
    //     })
    //     // let nameComp = reqJsonCompanies.companies[0].id;
    //     // console.log('nameComp >>>>', nameComp);
    //     setCompanies(industry_data);
    //     // setCompanies([{
    //     //    label:reqJsonCompany.company.company_name,
    //     //    value:reqJsonCompany.company.id
    //     // }]);
    //     setCompaniesValue({
    //       ...companiesValue,
    //       main_comp: industry_data[0].value,
    //       super_admin: false
    //     })
    //     if(currentRoute === 'TeamScreen'){
    //       fetchCompanyUsers(industry_data[0].value)
    //     }
    //   }
    // }
  }

  const getTeamData = (companyId) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let tokenNew = data.token;

    let params = { company_id: companyId };

    console.log("COMPANY ID >>>>>>>>>>>>,", companyId);

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/user/get_users?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + tokenNew,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg == "success") {
          console.log("RESPONSE TEAM >>>>", response);
          dispatch(addTeam(response));
          setTeams(response.data);
        }
      })
      .catch((error) => console.log(error.message));
  };

  //let data = useSelector((state) => state.companyReducer.company);
  useEffect(
    () => {
      // setCurrentCompany(data);
      getTeamData(data.id);
      console.log("data effect");
    },
    [data]
  );

  useEffect(
    () => {
      getCompaniesDetail(data2.token, data2.organization_id, data2);
    },
    [data2]
  );

  useEffect(() => {
    getAllLicenses();
    getPackageDetails();
  }, []);

  useEffect(
    () => {
      getPermissions();
    },
    [company?.id]
  );

  const getAllLicenses = () => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;

    let params = {
      organization_id: data.organization_id,
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Package/get_organization_licenses?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.msg === "success") {
          setLicenses(response.licenses);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getPermissions = () => {
    console.log("$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    if (data !== null) {
      let params = { company_id: company?.id, user_id: data?.user_id };
      let query = Object.keys(params)
        .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
        .join("&");

      fetch(GlobalApi + "/User/get_user_permission_of_company?" + query, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      })
        .then((responseJson) => responseJson.json())
        .then(async (response) => {
          console.log(response);
          if (response.msg === "success") {
            let permissionsObj = {};
            await response.data.map((v) => {
              permissionsObj[(v?.title)] = true;
            });
            console.log("Permissions Obj >>>>>>>", permissionsObj);

            setPermissionObj(permissionsObj);
          } else if (
            response.error === "jwt expired" ||
            response.error === "invalid token" ||
            response.error === "invalid signature" ||
            response.error === "jwt malformed" ||
            response.error === "Unexpected token"
          ) {
            let status = await refresh_token();
            // console.log(status);
            if (status) {
              // console.log("opopopop");
              getPermissions();
            }
          }
        })
        .catch((error) => {
          // localStorage.clear();
          // window.location.replace("/signin");
          console.log("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF", error.message);
        });
    }
  };

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();
    if (
      reqJson?.package?.license?.status === "expired" ||
      reqJson?.package?.license?.status === "deactive"
    ) {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }

  async function userStatusChange(status, userId, key) {
    console.log("status", status);
    console.log("user Id", userId);
    if (status == "active") {
      let _teams = [...teams];
      _teams[key].status = "deactivated";
      setTeams(_teams);
      try {
        let userDeactive = await fetch(GlobalApi + "/user/deactivate_users", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            user_id: userId,
          }),
        });
        let response = await userDeactive.json();
        console.log("Deactive user >>>>>", response);
        if (response.status === "Success") {
          await getTeamData(data.id);
          swal(
            t("Success"),
            t("Team Member Status changed Succesfully"),
            "success"
          );
          if (userId == data2.user_id) {
            logout();
          }
        }
      } catch (error) {
        console.log("Error :::", error);
      }
    } else if (status == "deactivated") {
      let _teams = [...teams];
      _teams[key].status = "active";
      setTeams(_teams);
      try {
        let userDeactive = await fetch(GlobalApi + "/user/activate_users", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            user_id: userId,
          }),
        });
        let response = await userDeactive.json();
        console.log("Active user >>>>>", response);
        if (response.status === "Success") {
          await getTeamData(data.id);
          swal(
            t("Success"),
            t("Team Member Status changed Successfully"),
            "success"
          );

          //  setUserData({
          //   ...userData,
          //   status:'active'
          // })
        }
      } catch (error) {
        console.log("Error :::", error);
      }
    }
  }

  let uploadProfileImage = async (singleFile = null) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    //Check if any file is selected or not
    if (singleFile != null) {
      //If file selected then create FormData
      const fileToUpload = singleFile;
      const data = new FormData();
      data.append("name", fileToUpload.name);
      data.append("company_id", company.id);
      data.append("user_id", data.id);
      data.append("images", fileToUpload);
      try {
        let res = await fetch(GlobalApi + "/user/image_upload", {
          method: "post",
          body: data,
          headers: new Headers({
            Authorization: "Bearer " + token,
            // "Content-Type": "multipart/form-data; ",
          }),
        });
        let responseJson = await res.json();
        if (responseJson.status == "Success") {
          console.log("Image Uploaded>>>>>>>", responseJson);
          setProfileImageUrl(responseJson.data);
          setTeamData({
            ...teamData,
            profilePic: responseJson.data,
          });
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("Please Select File first");
    }
  };

  let uploadSignatureImage = async (singleFile = null) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    //Check if any file is selected or not
    if (singleFile != null) {
      //If file selected then create FormData
      const fileToUpload = singleFile;
      const data = new FormData();

      console.log(fileToUpload.name);

      data.append("name", fileToUpload.name);
      data.append("company_id", company.id);
      data.append("user_id", data.id);
      data.append("images", fileToUpload);
      try {
        let res = await fetch(GlobalApi + "/user/image_upload", {
          method: "post",
          body: data,
          headers: new Headers({
            Authorization: "Bearer " + token,
            // "Content-Type": "multipart/form-data; ",
          }),
        });
        let responseJson = await res.json();
        if (responseJson.status == "Success") {
          console.log("Image Uploaded>>>>>>>", responseJson);
          // setProfileImageUrl(responseJson.data);
          setTeamData({
            ...teamData,
            signature_filename: fileToUpload.name,
            signature: responseJson.data,
          });
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      alert("Please Select File first");
    }
  };

  const handleSubmit = (e) => {
    let localstorage = localStorage.getItem("UserData");
    var localData = JSON.parse(localstorage);
    setBtnLoader(true);
    if (!editMode) {
      let obj = teamData;
      let {
        first_name,
        last_name,
        job_title,
        email,
        password,
        confirmPassword,
        profilePic,
        signature_filename,
        signature,
        license_id,
      } = obj;
      console.log(obj);

      let errors = {};

      //if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) === false) {
      if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          email.replace(" ", "")
        ) === false
      ) {
        errors.email = "Please Enter a Valid Email.";
      }

      if (first_name.length <= 0) {
        errors.first_name = "First Name is required";
      }
      if (last_name.length <= 0) {
        errors.last_name = "Last Name is required";
      }
      if (license_id == "") {
        errors.license_id = "License Id is required";
      }
      if (password.length < 6) {
        errors.password = "Password Should atleast be 6 characters long";
      }
      if (!hasValidLength(password)) {
        errors.password = "Your password must have 8 or more characters";
      }
      if (!hasMixed(password)) {
        errors.password = "Your password must have upper & lowercase letters";
      }
      // if (!job_title) {
      //   errors.job_title = "Job title required";
      // }
      // if (!signature) {
      //   errors.signature = "Signature required"
      // }
      if (!hasNumber(password)) {
        errors.password = "Your password must have at least one number";
      }
      if (!hasSpecial(password)) {
        errors.password =
          "Your password must have at least one special character";
      }
      if (password !== confirmPassword) {
        errors.confirmPassword = "password mismatch";
      }
      let flag = false;
      for (const iterator of companies) {
        if (iterator.checked == true) {
          flag = true;
        }
      }
      if (flag == false) {
        swal("Error", "Atleast One Company Required", "error");
        setBtnLoader(false);
        errorObj.company = "Atleast One Company Required.";
      }

      setErrorObj(errors);

      if (Object.keys(errors).length !== 0) {
        setBtnLoader(false);
      }

      if (Object.keys(errors).length === 0 && flag == true) {
        let abcd = [];
        for (const iterator of companies) {
          if (iterator.checked == true) {
            abcd.push(iterator);
          }
        }

        let finalCompany = [];
        for (const iterator2 of abcd) {
          let fetchP = iterator2.permissions;
          let myPermissions = [];
          for (const iterator3 of fetchP) {
            if (iterator3.checked == true) {
              myPermissions.push(iterator3.permission_id);
            }
          }
          let obj = {
            company_id: iterator2.id,
            role: iterator2.role,
            permissions: myPermissions,
          };
          finalCompany.push(obj);
        }

        console.log("final Company____________________", finalCompany);

        fetch(GlobalApi + "/user/add_team_member", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            ...obj,
            phone: phoneNumber,
            companies: finalCompany,
            created_by: userData.user_id,
            organization_id: userData.organization_id,
            status: "active",
            identifier: "User",
            // set_password_later: true,
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("Created Team Member >>>>", res);
            if (res.msg === "success") {
              setBtnLoader(false);
              swal("Success", "Team Member Added Successfully", "success");
              getAllLicenses();
              getTeamData(data.id);
              getPackageDetails();
              getCompaniesDetail(token, userData.organization_id, userData);
              resetFields();
            } else {
              swal("Error", res.error, "error");
              setBtnLoader(false);
            }
          })
          .catch((err) => {
            console.log("catch?????????????????", err);
            swal("Error", err.error, "error");
            setBtnLoader(false);
          });
      }
    } else if (editMode) {
      let obj = teamData;
      let {
        first_name,
        last_name,
        job_title,
        email,
        password,
        confirmPassword,
        profilePic,
        signature_filename,
        signature,
        license_id,
      } = obj;
      let errors = {};

      console.log(obj.password);

      if (obj.password == "") {
        console.log("if statement Exexuted");
        delete obj.password;
        delete obj.confirmPassword;
      } else {
        if (!hasNumber(password)) {
          errors.password = "Your password must have at least one number";
        }
        if (!hasSpecial(password)) {
          errors.password =
            "Your password must have at least one special character";
        }
        if (password !== confirmPassword) {
          errors.confirmPassword = "password mismatch";
        }
      }
      console.log("Edit Mode", obj);

      if (
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
          email.replace(" ", "")
        ) === false
      ) {
        errors.email = "Please Enter a Valid Email.";
      }

      if (first_name.length <= 0) {
        errors.first_name = "First Name is required";
      }
      if (last_name.length <= 0) {
        errors.last_name = "Last Name is required";
      }
      if (license_id == "") {
        errors.license_id = "License Id is required";
      }
      let flag = false;
      for (const iterator of companies) {
        if (iterator.checked == true) {
          flag = true;
        }
      }
      if (flag == false) {
        swal("Error", "Atleast One Company Required", "error");
        setBtnLoader(false);
        errorObj.company = "Atleast One Company Required.";
      }

      if (obj.password == "" || obj.password == undefined) {
        console.log("if error statement Exexuted", errors);
        delete errors.password;
        delete errors.confirmPassword;
        setErrorObj(errors);
      } else {
        setErrorObj(errors);
      }

      if (Object.keys(errors).length !== 0) {
        setBtnLoader(false);
      }

      if (Object.keys(errors).length === 0 && flag == true) {
        let abcd = [];
        for (const iterator of companies) {
          if (iterator.checked == true) {
            abcd.push(iterator);
          }
        }

        let finalCompany = [];
        for (const iterator2 of abcd) {
          let fetchP = iterator2.permissions;
          let myPermissions = [];
          for (const iterator3 of fetchP) {
            if (iterator3.checked == true) {
              myPermissions.push(iterator3.permission_id);
            }
          }
          let obj = {
            company_id: iterator2.id,
            role: iterator2.role,
            permissions: myPermissions,
          };
          finalCompany.push(obj);
        }

        console.log("_______________________FINAL COMPANY");
        console.log(finalCompany);
        fetch(GlobalApi + "/user/edit_user", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            ...obj,
            phone: phoneNumber,
            company: finalCompany,
            user_id: currentEditUser,
            // set_password_later: true,
          }),
        })
          .then((response) => response.json())
          .then(async (res) => {
            console.log("upadated Team Member >>>>", res);
            if (res.status === "success") {
              swal("Success", "Team Member Updated Successfully", "success");
              if (res.data.id === localData.id) {
                let newData = {
                  ...localData,
                  ...res.data,
                };
                dispatch(addUser(newData));
                localStorage.setItem("UserData", JSON.stringify(newData));
                getAllLicenses();
              }
              getTeamData(data.id);
              getCompaniesDetail(token, userData.organization_id, userData);
              resetFields();
              setBtnLoader(false);
              setEditMode(false);
            } else {
              console.log(res.err);
              swal("Error", res.error || "Something went wrong", "error");
              setBtnLoader(false);
            }
          })
          .catch((err) => {
            console.log(err);
            setBtnLoader(false);
          });
      }
    }
  };

  const classes = useStyles();
  return <div className={isOnboarding == true ? "scrollHidden" : ""} style={{ width: "100%", padding: isOnboarding == true ? (window.innerWidth > 500 ? "20px 1px 20px 20px" : "10px 1px 10px 10px") : "0px", backgroundColor: Colors.globalColor9, overflowX: "hidden", overflowY: "scroll", height: "77vh  " }}>
      <div style={{ backgroundColor: "white", borderRadius: "10px", boxShadow: isOnboarding == true && "0 1px 4px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19)", padding: isOnboarding == true ? "20px" : "20px 0px 0px " }}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} sm={12} md={2} lg={2} style={{ textAlign: "center" }}>
            {parseInt(packageDetails?.no_of_users) > parseInt(packageDetails?.user_count) ? <>
                {" "}
                {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <input className={classes.input} id="icon-button-file" type="file" onChange={(e) => uploadProfileImage(e.target.files[0])} /> : <input disabled className={classes.input} id="icon-button-file" type="file" />
                // onChange={(e) => uploadProfileImage(e.target.files[0])}
                }
              </> : <>
                {editMode ? (
                  <input
                    className={classes.input}
                    id="icon-button-file"
                    type="file"
                    onChange={(e) => uploadProfileImage(e.target.files[0])}
                  />
                ) : (
                  <input
                    disabled
                    className={classes.input}
                    id="icon-button-file"
                    type="file"
                  />
                )}
              </>}
            <label htmlFor="icon-button-file">
              <IconButton color="primary" aria-label="upload picture" component="span" style={{ width: "120px", height: "120px", marginTop: "5%", backgroundImage: `url(https://server.uraudits.com/view?Key=${teamData.profilePic})`, backgroundSize: "cover", backgroundColor: Colors.globalColor5, boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
                <PhotoCamera fontSize="large" style={{ color: !teamData.profilePic ? "#dee0e1" : "transparent" }} />
              </IconButton>
            </label>
            <p className="label1Team">{t("User Photo")}</p>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p className="label2" style={{ color: Colors.globalColor8, marginTop: 0 }}>
                {t("Add a User to Your Team")}
              </p>
              <Tooltip title={t("Help")} style={{ marginTop: "10px" }}>
                <a href="https://www.uraudits.com/knowledge-center/team/" target="blank" style={{ color: Colors.globalColor8 }}>
                  <img src={language == "ar" ? helpAr : help} height={25} style={{ marginLeft: "5px" }} />
                </a>
              </Tooltip>
            </div>
            <p className="label4" style={{ marginBottom: 20, marginTop: 0, color: "black" }}>
              {t("current seat usage")} {packageDetails?.user_count + "/" + packageDetails?.no_of_users}
            </p>

            <form>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("First Name")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="first_name" InputProps={{ classes: { input: classes.resize } }} error={errorObj.first_name} helperText={errorObj.first_name} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={teamData.first_name} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Last Name")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="last_name" InputProps={{ classes: { input: classes.resize } }} error={errorObj.last_name} helperText={errorObj.last_name} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={teamData.last_name} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Job Title")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="job_title" InputProps={{ classes: { input: classes.resize } }} error={errorObj.job_title} helperText={errorObj.job_title} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={teamData.job_title} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Email")}</p>
                      <TextField className="inputTextBox" fullWidth id="outlined-basic" name="email" InputProps={{ classes: { input: classes.resize } }} error={errorObj.email} helperText={errorObj.email} onChange={handleInputChange} variant="outlined" autoComplete={"off"} size="small" value={teamData.email} />
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Phone")}</p>
                      <div style={{ border: "1px solid #dadada", borderRadius: "5px", backgroundColor: Colors.globalColor5, width: "100%", height: "35px", display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "0px 5px" }}>
                        <PhoneInput className="phoneInp" value={phoneNumber} autoComplete="off" onChange={setPhoneNumber} />
                      </div>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Company">{t("Select license")} </p>
                      <TextField id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Avalible Licenses")} name="license_id" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange} helperText={errorObj.license_id} value={teamData.license_id} variant="outlined">
                        {licenses.map((item, index) => {
                          if (item.user === null && item.status === "active") {
                            return <MenuItem value={item.license_id} style={{ fontSize: 14 }}>
                                {item.license_id}
                              </MenuItem>;
                          }
                        })}
                      </TextField>
                    </Grid>

                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Signature")}</p>
                      <div style={{ border: "1px solid #d7dee4", borderRadius: "5px", backgroundColor: Colors.globalColor5, width: "100%", height: "35px", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0px 5px" }}>
                        <div style={{ width: "50%", textAlign: language == "ar" ? "right" : "left", overflow: "hidden" }}>
                          <p>{teamData.signature_filename}</p>
                        </div>
                        <div style={{ width: "50%", textAlign: "right" }}>
                          <input accept="image/*" className={classes.input} id="contained-button-file" multiple type="file" onChange={(e) => uploadSignatureImage(e.target.files[0])} />
                          <label htmlFor="contained-button-file">
                            <Button variant="outlined" className="uploadBtn" component="span">
                              {t("Browse for File")}
                            </Button>
                          </label>
                        </div>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Password")}</p>
                      <FormControl className={(classes.password, classes.textField)} variant="outlined" fullWidth size="small" InputProps={{ classes: { input: classes.resize }, autoComplete: "off" }}>
                        <CustomToolTip>
                          <OutlinedInput error={errorObj.password} size="small" helperText={errorObj.password} name="password" className={"passwordTextbox"} id="outlined-adornment-password" type={values.showPassword ? "text" : "password"} value={teamData.password} onChange={handleInputChange} endAdornment={<InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility" onClick={handleClickShowPassword} edge="end" className="eyeIcon">
                                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                                </IconButton>
                              </InputAdornment>} />
                        </CustomToolTip>
                        <span style={{ color: "red", fontSize: "12px" }}>
                          {errorObj.password}
                        </span>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <p className="label1Team">{t("Confirm Password")}</p>
                      <FormControl className={classes.textField} variant="outlined" fullWidth size="small">
                        {" "}
                        <OutlinedInput error={errorObj.password_confirm} helperText={errorObj.password_confirm} fullWidth name="confirmPassword" className={"passwordTextbox"} size="small" id="outlined-adornment-password" type={values.showPasswordConfirm ? "text" : "password"} value={teamData.confirmPassword} onChange={handleInputChange} endAdornment={<InputAdornment position="end">
                              <IconButton aria-label="toggle password visibility" onClick={handleClickShowPasswordConfirm} edge="end" className="eyeIcon">
                                {values.showPasswordConfirm ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>} />
                        <span style={{ color: "red", fontSize: "12px", marginLeft: 15 }}>
                          {errorObj.confirmPassword}
                        </span>
                      </FormControl>
                    </Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={12}>
                  <Grid container spacing={2}>
                  
                  </Grid>
                </Grid> */}

                {companies.length > 0 && <Grid item xs={12}>
                    <p className="label2">
                      {t("Select Company To Add User")}
                    </p>
                  </Grid>}

                {companies.length > 0 && companies.map((item, index) => {
                    console.log("item", item);
                    return <>
                        <div style={{ border: "1px solid #d7dee4", borderRadius: "5px", marginTop: "5px", backgroundColor: Colors.globalColor5, width: "100%", minHeight: "40px", display: "flex", alignItems: "center", justifyContent: "flex-start", padding: "0px 10px" }}>
                          <Grid container>
                            <Grid item xs={12}>
                              <div>
                                <Checkbox style={{ color: Colors.globalColor8 }} checked={item.checked} onChange={(e) => onCheckCompany(e.target.checked, index)} />
                                {item.company_name}
                              </div>
                            </Grid>
                            {item.checked == true && <Grid item xs={12}>
                                {packageDetails?.package?.title == "Enterprise" || ("Free" && <Grid item xs={12} sm={12} md={4} lg={4}>
                                      <p className="label1Team">
                                        {t("Select User Role")}
                                      </p>
                                      <TextField id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder="Select Business Industry" name="role" InputProps={{ classes: { input: classes.resize } }} onChange={(e) => handleRoleChange(index, e.target.value)} helperText={errorObj.role} value={item.role} variant="outlined">
                                        <MenuItem value={"admin"} style={{ fontSize: 14 }}>
                                          {"Admin"}
                                        </MenuItem>
                                        <MenuItem value={"inspector"} style={{ fontSize: 14 }}>
                                          {"Inspector"}
                                        </MenuItem>
                                        <MenuItem value={"management"} style={{ fontSize: 14 }}>
                                          {"Management"}
                                        </MenuItem>
                                      </TextField>
                                    </Grid>)}
                                <p className="label1Team">
                                  {t("Manage Access Rights")}
                                </p>
                                <Grid container spacing={0}>
                                  {item.permissions.map(
                                    (subItem, subIndex) => {
                                      return (
                                        <Grid
                                          item
                                          xs={12}
                                          sm={12}
                                          md={4}
                                          lg={4}
                                        >
                                          <Checkbox
                                            style={{
                                              color: Colors.globalColor8,
                                            }}
                                            checked={subItem.checked}
                                            onChange={(e) =>
                                              onCheckPermission(
                                                e.target.checked,
                                                index,
                                                subIndex
                                              )
                                            }
                                          />
                                          <p className="checkboxTitle2">
                                            {subItem.title}
                                          </p>
                                        </Grid>
                                      );
                                    }
                                  )}
                                </Grid>
                              </Grid>}
                          </Grid>
                        </div>
                      </>;
                  })}

                <Grid item xs={12} style={{ marginTop: "20px" }}>
                  {editMode ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                      {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {"Update User"}
                    </Button> : <>
                      {parseInt(packageDetails?.no_of_users) > parseInt(packageDetails?.user_count) ? <>
                          {" "}
                          {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <Button variant="contained" type="submit" className="addBtn" component="span" onClick={(e) => handleSubmit(e)}>
                              {btnLoader == true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />} {"Add User"}
                            </Button> : <Button variant="contained" type="submit" className="addBtn2" component="span" disabled={true} style={{ backgroundColor: "#dadada" }}>
                              {t("Add User")}
                            </Button>}
                        </> : <Link to="/update_package">
                          <Button variant="contained" type="submit" className="addBtn" component="span">
                            {t("Upgrade Package")}
                          </Button>
                        </Link>}
                    </>}
                  &nbsp;
                  <Button variant="contained" className="cancelBtn" onClick={() => handleCancel()}>
                    {t("Cancel")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
          <Grid item xs={12} sm={2} md={2} lg={2} style={{ textAlign: "center" }} />
        </Grid>

        <Grid container spacing={3} justifyContent="center">
          {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
          <Grid item xs={12} sm={12} md={isOnboarding == false ? 10 : 12} lg={isOnboarding == false ? 10 : 12}>
            {window.innerWidth > 500 && <br />}
            {window.innerWidth > 500 && <TableContainer style={{ backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
                <Table sx={{ minWidth: 900 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align={language == "ar" ? "right" : "left"}>
                        <p className="label3" style={{ color: Colors.globalColor8, textTransform: "uppercase" }}>
                          {t("Name")}
                        </p>
                      </TableCell>
                      <TableCell align={language == "ar" ? "right" : "left"}>
                        <p className="label3" style={{ color: Colors.globalColor8, textTransform: "uppercase" }}>
                          {t("Email")}
                        </p>
                      </TableCell>
                      <TableCell align={language == "ar" ? "right" : "left"}>
                        <p className="label3" style={{ color: Colors.globalColor8, textTransform: "uppercase" }}>
                          {t("Phone")}
                        </p>
                      </TableCell>
                      <TableCell align="center">
                        <p className="label3" style={{ color: Colors.globalColor8, textTransform: "uppercase" }}>
                          {t("Action")}
                        </p>
                      </TableCell>
                      <TableCell align="center">
                        <p className="label3" style={{ color: Colors.globalColor8, textTransform: "uppercase" }}>
                          {t("Status")}
                        </p>
                      </TableCell>
                      <TableCell align="center"> </TableCell>
                      <TableCell align="center"> </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teams == null && <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                        <CircularProgress style={{ color: Colors.globalColor8 }} />
                      </div>}
                    {teams != null && teams.map((item, index) => {
                        console.log("ITEM>>>>>>>>", item);
                        return <TableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 1 } }}>
                            <TableCell align={language == "ar" ? "right" : "left"} padding="normal">
                              {item.first_name} {item.last_name}
                            </TableCell>
                            <TableCell align={language == "ar" ? "right" : "left"} padding="none">
                              {item.email}
                            </TableCell>
                            <TableCell align={language == "ar" ? "right" : "left"} padding="none">
                              {item.phone}
                            </TableCell>
                            <TableCell align="center" padding="none">
                              {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <>
                                  {" "}
                                  {item.organization_id === null ? <Switch className="statusSwitchTeam" checked={item.status === "active"} onChange={() => userStatusChange(item.status, item.id, index)} name="checkedB" style={{ color: Colors.globalColor8 }} /> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                                </> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                            </TableCell>
                            <TableCell align="center" padding="none">
                              {item.status == "active" ? <p style={{ color: "green", margin: 0 }}>
                                  {item.status}
                                </p> : <p style={{ color: "red", margin: 0 }}>
                                  {item.status}
                                </p>}
                            </TableCell>
                            <TableCell padding="none" align="right" style={{ maxWidth: "100px" }}>
                              {userData?.super_admin == true && item?.organization_id != null ? <IconButton aria-label="delete" onClick={() => confirmDeleteUser(item.id, item?.organization_id)}>
                                  <img src={Delete} alt="delete" />
                                  <p className="label1Team" style={{ fontSize: 12 }}>
                                    {t("Remove")}
                                  </p>
                                </IconButton> : <>
                                  {(userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true) && item?.organization_id == null ? <IconButton aria-label="delete" onClick={() => confirmDeleteUser(item.id, item?.organization_id)}>
                                      <img src={Delete} alt="delete" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Remove")}
                                      </p>
                                    </IconButton> : <IconButton disabled aria-label="delete">
                                      <img src={DeleteG} alt="delete" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Remove")}
                                      </p>
                                    </IconButton>}
                                </>}

                              {/* {userData?.super_admin == true ||
                              permissions_obj["Admin"] == true ||
                              permissions_obj["User Management"] == true ? (
                                <>
                                  {(item.organization_id === null )? (
                                    <IconButton
                                      aria-label="delete"
                                      onClick={() => confirmDeleteUser(item.id)}
                                    >
                                      <img src={Delete} alt="delete" />
                                      <p
                                        className="label1Team"
                                        style={{ fontSize: 12 }}
                                      >
                                        {t("Remove")}
                                      </p>
                                    </IconButton>
                                  ) : (
                                    <IconButton disabled aria-label="delete">
                                      <img src={DeleteG} alt="delete" />
                                      <p
                                        className="label1Team"
                                        style={{ fontSize: 12 }}
                                      >
                                        {t("Remove")}
                                      </p>
                                    </IconButton>
                                  )}
                                </>
                              ) : (
                                <IconButton disabled aria-label="delete">
                                  <img src={DeleteG} alt="delete" />
                                  <p
                                    className="label1Team"
                                    style={{ fontSize: 12 }}
                                  >
                                    {t("Remove")}
                                  </p>
                                </IconButton>
                              )} */}
                            </TableCell>
                            <TableCell padding="none" align="right" style={{ maxWidth: "100px" }}>
                              {item.organization_id != null ? <>
                                  {userData?.super_admin == true ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                      <img src={Edit} alt="edit" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Edit")}
                                      </p>
                                    </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                      <img src={EditG} alt="edit" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Edit")}
                                      </p>
                                    </IconButton>}
                                </> : <>
                                  {userData?.super_admin == true || permissions_obj["User Management"] !== undefined || permissions_obj["Admin"] !== undefined ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                      <img src={Edit} alt="edit" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Edit")}
                                      </p>
                                    </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                      <img src={EditG} alt="edit" />
                                      <p className="label1Team" style={{ fontSize: 12 }}>
                                        {t("Edit")}
                                      </p>
                                    </IconButton>}
                                </>}
                              {/* {item.organization_id != null ? <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                    <img src={EditG} alt="edit" />
                                    <p className="label1Team" style={{ fontSize: 12 }}>
                                      Edit
                                    </p>
                                  </IconButton> : <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                    <img src={Edit} alt="edit" />
                                    <p className="label1Team" style={{ fontSize: 12 }}>
                                      Edit
                                    </p>
                                  </IconButton>} */}

                              {/* {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                    <img src={Edit} alt="edit" />
                                    <p className="label1Team" style={{ fontSize: 12 }}>
                                      Edit
                                    </p>
                                  </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                    <img src={EditG} alt="edit" />
                                    <p className="label1Team" style={{ fontSize: 12 }}>
                                      Edit
                                    </p>
                                  </IconButton>} */}
                            </TableCell>
                          </TableRow>;
                      })}
                  </TableBody>
                </Table>
              </TableContainer>}

            {window.innerWidth <= 500 && <div>
                {teams == null && <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                    <CircularProgress style={{ color: Colors.globalColor8 }} />
                  </div>}
                {teams != null && teams.map((item, index) => {
                    console.log("ITEM>>>>>>>>", item);
                    return <div className="hover shadow" style={{ display: "flex", justifyContent: "space-between", border: "1px solid #dadada", padding: "10px", margin: "5px", flexDirection: "row", alignItems: "center", textAlign: language == "ar" ? "right" : "left", height: "220px", borderRadius: "5px", backgroundColor: "white", overflow: "hidden" }}>
                        <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
                          <div>
                            <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                              {t("Name")}
                            </p>

                            <p style={{ fontSize: "12px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                              {item.first_name} {item.last_name}
                            </p>
                          </div>
                          {item.email && <div>
                              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {t("Email")}
                              </p>
                              <p style={{ fontSize: "12px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {item.email}
                              </p>
                            </div>}
                          {item.phone && <div>
                              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {t("Phone")}{" "}
                              </p>
                              <p style={{ fontSize: "12px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {item.phone}
                              </p>
                            </div>}

                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <>
                                <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                  {t("Action")}{" "}
                                </p>
                                {item.organization_id === null ? <Switch className="statusSwitchTeam" checked={item.status === "active"} onChange={() => userStatusChange(item.status, item.id, index)} name="checkedB" style={{ color: Colors.globalColor8 }} /> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                              </> : <Switch className="statusSwitchTeamDis" checked={item.status === "active"} disabled name="checkedB" style={{ color: "grey" }} />}
                          </div>

                          {item.country && <div>
                              <p style={{ color: Colors.globalColor8, fontWeight: "bold", fontSize: "14px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {t("Country")}{" "}
                              </p>
                              <p style={{ fontSize: "12px", textAlign: language == "ar" ? "right" : "left", marginBottom: "0px", marginTop: "0px" }}>
                                {item.country}
                              </p>
                            </div>}
                        </div>

                        <div style={{ display: "flex", height: "100%", flexDirection: "column", justifyContent: "space-between" }}>
                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <>
                                {item.organization_id === null ? <IconButton aria-label="delete" onClick={() => confirmDeleteUser(item.id)}>
                                    <img src={Delete} alt="delete" />
                                  </IconButton> : <IconButton disabled aria-label="delete">
                                    <img src={DeleteG} alt="delete" />
                                  </IconButton>}
                              </> : <IconButton disabled aria-label="delete">
                                <img src={DeleteG} alt="delete" />
                              </IconButton>}
                          </div>

                          {item.status == "active" && <div>
                              <DoneAllIcon style={{ color: "green" }} />
                            </div>}

                          <div>
                            {userData?.super_admin == true || permissions_obj["Admin"] == true || permissions_obj["User Management"] == true ? <IconButton aria-label="delete" onClick={() => editUser(index, item.id)}>
                                <img src={Edit} alt="edit" />
                              </IconButton> : <IconButton disabled aria-label="edit" onClick={() => editUser(index, item.id)}>
                                <img src={EditG} alt="edit" />
                              </IconButton>}
                          </div>
                        </div>
                      </div>;
                  })}
              </div>}
            <br />
            <br />
          </Grid>
          {isOnboarding == false && <Grid item xs={0} sm={0} md={1} lg={1} />}
        </Grid>
      </div>

      <Modal open={openOnb}>
        <div className="modal-size" style={{ position: "relative" }}>
          <Typography variant="h6" className="modal-title">
            Account Deletion Survey
          </Typography>
         

          <Grid className="scrollHidden2" style={{ textAlign: "left",maxHeight:"60vh", overflow:"auto" }}>
            {/* <Grid item xs={12}>
              <p className="label1Company" style={{ fontSize: 14 }}>
                {t("What was the main reason for cancelling the service?")}{" "}
              </p>
              <TextField style={{ width: "100%" }} id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Reason")} name="reasonForLeaving" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange2} helperText={errorObj.reasonForLeaving} value={reason.reasonForLeaving} variant="outlined">
                <MenuItem value={"No longer need it"} style={{ fontSize: 14 }}>
                  No longer need it
                </MenuItem>
                <MenuItem value={"It diden't meet my needs"} style={{ fontSize: 14 }}>
                  It diden't meet my needs
                </MenuItem>
                <MenuItem value={"Expensive"} style={{ fontSize: 14 }}>
                  Expensive
                </MenuItem>
                <MenuItem value={"Found a better alternative"} style={{ fontSize: 14 }}>
                  Found a better alternative
                </MenuItem>
                <MenuItem value={"Quality issues"} style={{ fontSize: 14 }}>
                  Quality Issues
                </MenuItem>
                <MenuItem value={"Poor customer service"} style={{ fontSize: 14 }}>
                  Poor Customer Service
                </MenuItem>
                <MenuItem value={"Complex to use "} style={{ fontSize: 14 }}>
                  Complex to use
                </MenuItem>
                <MenuItem value={"Others"} style={{ fontSize: 14 }}>
                  Others
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <p className="label1Company" style={{ fontSize: 14 }}>
                {t("How long have you been using the service?")}{" "}
              </p>
              <TextField style={{ width: "100%" }} id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Reason")} name="usageTime" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange2} helperText={errorObj.usageTime} value={reason.usageTime} variant="outlined">
                <MenuItem value={"Less than a month"} style={{ fontSize: 14 }}>
                  Less than a month
                </MenuItem>
                <MenuItem value={"1 - 6 Months"} style={{ fontSize: 14 }}>
                  1 - 6 Months
                </MenuItem>
                <MenuItem value={"7 - 12 Months"} style={{ fontSize: 14 }}>
                  7 - 12 Months
                </MenuItem>
                <MenuItem value={"1 - 3 Years"} style={{ fontSize: 14 }}>
                  1 - 3 Years
                </MenuItem>
                <MenuItem value={"Over 3 years"} style={{ fontSize: 14 }}>
                  Over 3 Years
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <p className="label1Company" style={{ fontSize: 14 }}>
                {t("Will you use our service in the future?")}{" "}
              </p>
              <TextField style={{ width: "100%" }} id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Reason")} name="futureUse" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange2} helperText={errorObj.futureUse} value={reason.futureUse} variant="outlined">
                <MenuItem value={"Definitely"} style={{ fontSize: 14 }}>
                  Definitely
                </MenuItem>
                <MenuItem value={"Probably"} style={{ fontSize: 14 }}>
                  Probably
                </MenuItem>
                <MenuItem value={"Not Sure"} style={{ fontSize: 14 }}>
                  Not Sure
                </MenuItem>
                <MenuItem value={"Probably Not"} style={{ fontSize: 14 }}>
                  Probably Not
                </MenuItem>
                <MenuItem value={"Definitely Not"} style={{ fontSize: 14 }}>
                  Definitely Not
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <p className="label1Company" style={{ fontSize: 14 }}>
                {t("Will you recommend our service to others?")}{" "}
              </p>
              <TextField style={{ width: "100%" }} id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Reason")} name="recomendations" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange2} helperText={errorObj.recomendations} value={reason.recomendations} variant="outlined">
                <MenuItem value={"Definitely"} style={{ fontSize: 14 }}>
                  Definitely
                </MenuItem>
                <MenuItem value={"Probably"} style={{ fontSize: 14 }}>
                  Probably
                </MenuItem>
                <MenuItem value={"Not Sure"} style={{ fontSize: 14 }}>
                  Not Sure
                </MenuItem>
                <MenuItem value={"Probably Not"} style={{ fontSize: 14 }}>
                  Probably Not
                </MenuItem>
                <MenuItem value={"Definitely Not"} style={{ fontSize: 14 }}>
                  Definitely Not
                </MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12}>
              <p className="label1Company" style={{ fontSize: 14 }}>
                {t("Overall, how satisfied were you with the service?")}{" "}
              </p>
              <TextField style={{ width: "100%" }} id="outlined-select-currency" select fullWidth className={classes.textField} size="small" placeholder={t("Select Reason")} name="satisfaction" InputProps={{ classes: { input: classes.resize } }} onChange={handleInputChange2} helperText={errorObj.satisfaction} value={reason.satisfaction} variant="outlined">
                <MenuItem value={"Very satisfied"} style={{ fontSize: 14 }}>
                  Very satisfied
                </MenuItem>
                <MenuItem value={"Satisfied"} style={{ fontSize: 14 }}>
                  Satisfied
                </MenuItem>
                <MenuItem value={"Not Sure"} style={{ fontSize: 14 }}>
                  Not Sure
                </MenuItem>
                <MenuItem value={"Unsatisfied"} style={{ fontSize: 14 }}>
                  Unsatisfied
                </MenuItem>
                <MenuItem value={"Very Unsatisfied"} style={{ fontSize: 14 }}>
                  Very Unsatisfied
                </MenuItem>
              </TextField>
            </Grid> */}

            <Grid item xs={12}>
              <p className="label1Team">
                {t("Please share your reason for deleting the account")}
              </p>
              <TextareaAutosize placeholder="write your reason here" maxLength={200} style={{ height: "100px", width: "100%", borderRadius: "5px" }} rowsMax={4} fullWidth id="outlined-basic" name="suggestions" onChange={(e) => setReason(e.target.value)} aria-label="maximum height" value={reason} />
              <p className="label2Team" style={{fontSize:"10px",marginTop:0,color:reason.length == 200 && "red"}}>
                {`(${reason.length} / 200)`}
              </p>
              {/* <TextField className="inputTextBox" fullWidth id="outlined-basic" name="suggestions" InputProps={{ classes: { input: classes.resize } }} error={errorObj.suggestions} helperText={errorObj.suggestions} onChange={handleInputChange2} variant="outlined" autoComplete={"off"} size="small" value={teamData.suggestions} /> */}
            </Grid>
          </Grid>
          <br />
          <Button onClick={()=>handleDelete()} className="deleteBtn">Delete Account</Button>

          <div onClick={handleCloseOnb} style={{ padding: "5px", display: "inline-block", color: Colors.globalColor8, position: "absolute", top: 10, right: 10, cursor: "pointer" }}>
            <p style={{ margin: "0px", fontWeight: "bolder" }}>X</p>
          </div>
        </div>
      </Modal>
    </div>;
}

export default Team;
